import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=1a660211&scoped=true&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=1a660211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a660211",
  null
  
)

export default component.exports